import gql from 'graphql-tag';

export default gql`
  mutation createOneSubscriptionMutation($userName: String!, $type: String!, $categories: [MongoID!], $email: String!) {
    createOneSubscriptionMutation(userName: $userName, type: $type, categories: $categories, email: $email) {
      title
      message
    }
  }
`;
